<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      resetState: 'review/resetState',
    }),
  },
  destroyed() {
    this.resetState();
  },
};
</script>

<template>
    <div class="review-wrapper">
        <v-content>
            <router-view/>
        </v-content>
    </div>
</template>

<style lang="scss">
    .review-wrapper {
        &__spinner {
            height: calc(100vh - 64px);
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/ReviewWrapper.vue